/* eslint-disable @typescript-eslint/no-explicit-any */
/* Employee — Allowances. Reuses the existing DualModeInput for the
   percentage-of-basic / fixed-amount toggle; labels are spelled out
   (Leave Encashment, not LEA). */
import React from "react";
import Input from "components/Input";
import DualModeInput from "components/Input/DualModeInput";
import { preventSpecialCharKeyDown } from "util/preventSpecialCharInput";
import { SectionCard, HelperText } from "./_controls";

const Divider = () => <div className="my-4 border-t border-slate-100 dark:border-gray-700" />;

const EmployeeAllowancesSection = () => (
  <SectionCard title="Allowances" subtitle="Configure fixed or percentage-based allowances.">
    {/* Conveyance */}
    <div className="max-w-md">
      <DualModeInput
        compact
        name="conveyanceAllowance"
        flagName="conveyanceIsPercentage"
        percentageLabel="Conveyance (% of Basic Salary)"
        amountLabel="Conveyance (₹ / year)"
        defaultIsPercentage={false}
      />
    </div>

    <Divider />

    {/* Medical Allowance */}
    <div className="max-w-md">
      <DualModeInput
        compact
        name="medicalAllowance"
        flagName="medicalAllowanceIsPercentage"
        percentageLabel="Medical Allowance (% of Basic Salary)"
        amountLabel="Medical Allowance (₹ / year)"
        defaultIsPercentage={false}
      />
    </div>

    <Divider />

    {/* Leave Encashment */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 max-w-2xl">
      <div>
        <Input
          compact
          name="leaDays"
          label="Leave Encashment — Eligible Leave Days"
          type="number"
          onKeyDown={preventSpecialCharKeyDown}
        />
        <HelperText>Encashment = Annual CTC ÷ 365 × eligible days.</HelperText>
      </div>
      <DualModeInput
        compact
        name="leaMonthly"
        flagName="leaIsPercentage"
        percentageLabel="Leave Encashment (% of Basic Salary)"
        amountLabel="Leave Encashment (₹ / month)"
        defaultIsPercentage={false}
      />
    </div>
  </SectionCard>
);

export default EmployeeAllowancesSection;
